import { z } from 'zod';
import { ADMIN_MENU_ACTIONS, GRANTABLE_ADMIN_MENU_KEYS } from '../lib/adminMenus.js';
// ============================================================
// 권한 그룹(admin_roles) — FIKET-417
// ============================================================
export const AdminMenuActionSchema = z.enum(ADMIN_MENU_ACTIONS);
/** { 메뉴키: 액션[] } — 부여 가능한 메뉴키만 허용(roles 등 adminOnly 는 거부). 서버가 normalize 해서 저장 */
export const AdminMenuGrantsSchema = z.partialRecord(z.enum(GRANTABLE_ADMIN_MENU_KEYS), z.array(AdminMenuActionSchema).max(ADMIN_MENU_ACTIONS.length));
/** 시스템 예약 그룹(ADMIN)의 가상 id — DB 행이 아니다 */
export const ADMIN_SYSTEM_ROLE_ID = 'ADMIN';
export const AdminRoleNameSchema = z.string().trim().min(1, '그룹 이름을 입력하세요').max(60, '그룹 이름은 60자 이하');
export const AdminRoleDescriptionSchema = z.string().trim().max(500, '설명은 500자 이하').nullable();
export const AdminRoleCreateSchema = z.object({
    name: AdminRoleNameSchema,
    description: AdminRoleDescriptionSchema.optional(),
    grants: AdminMenuGrantsSchema,
});
// Create.partial() 로 만들지 않는다 — 기본값이 빈 PATCH 를 덮어쓰는 zod v4 함정 회피
export const AdminRoleUpdateSchema = z.object({
    name: AdminRoleNameSchema.optional(),
    description: AdminRoleDescriptionSchema.optional(),
    grants: AdminMenuGrantsSchema.optional(),
});
export const AdminRoleSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    grants: z.record(z.string(), z.array(AdminMenuActionSchema)),
    /** 배정된 사용자 수 — 0 일 때만 삭제 가능 */
    memberCount: z.number().int(),
    /** ADMIN 시스템 그룹 — 삭제·수정 불가, grants 는 전권 의미로 비어 있다 */
    isSystem: z.boolean(),
    createdAt: z.string().nullable(),
    updatedAt: z.string().nullable(),
});
export const AdminRoleMemberSchema = z.object({
    id: z.string(),
    email: z.string(),
    name: z.string().nullable(),
    role: z.string(),
});
//# sourceMappingURL=admin-roles.js.map